import React from 'react';
import classNames from 'classnames';

import { FieldContainer, FieldContainerProps } from './FieldContainer';
import { FieldStyles } from './styles/FieldStyles';

import { FieldWrapperProps } from 'components/fields/FieldWrapper';
import { createStyle, createStyles } from 'utils/createStyle';

export type TextAreaFieldProps = FieldContainerProps &
    FieldWrapperProps &
    React.InputHTMLAttributes<HTMLTextAreaElement> & {
        inputRef?: React.Ref<HTMLTextAreaElement>;
    };

const styles = createStyles({
    charCounter: createStyle('text-xs text-grey-3 text-right'),
});

export const TextAreaField = (props: TextAreaFieldProps) => {
    const { label, error, className, inputRef, value, maxLength, ...inputProps } = props;
    const length = value != null ? value.toString().length : 0;

    return (
        <FieldContainer label={label} error={error}>
            <div>
                <textarea
                    className={classNames(FieldStyles.field, className, { error: Boolean(error) })}
                    ref={inputRef}
                    {...inputProps}
                    value={value}
                    maxLength={maxLength}
                />
                {maxLength && maxLength > 0 && (
                    <div className={styles.charCounter}>
                        {length}/{maxLength}
                    </div>
                )}
            </div>
        </FieldContainer>
    );
};
